import React, { Component } from "react";
import Moment from "react-moment";
import { Link } from "react-router-dom";
import http from "../../Services/httpService";
import auth from "../../Services/authService";
import config from "../../config.json";

const SURVEY_STYLES = {
  pageWrap: {
    padding: "8px 0 4px 0"
  },
  shell: {
    borderRadius: "20px",
    border: "1px solid rgba(226, 232, 240, 0.95)",
    backgroundColor: "#ffffff",
    boxShadow: "0 10px 30px rgba(15, 23, 42, 0.05)",
    overflow: "hidden"
  },
  hero: {
    padding: "18px 22px",
    borderBottom: "1px solid rgba(226, 232, 240, 0.9)",
    background: "linear-gradient(135deg, #f8fafc 0%, #eff6ff 100%)"
  },
  heroRow: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    gap: "16px",
    flexWrap: "wrap"
  },
  titleWrap: {
    minWidth: 0,
    display: "flex",
    alignItems: "center",
    gap: "12px"
  },
  titleIcon: {
    width: "34px",
    height: "34px",
    borderRadius: "10px",
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    background: "#ffffff",
    color: "#2563eb",
    fontSize: "14px",
    border: "1px solid rgba(191, 219, 254, 0.9)",
    boxShadow: "0 4px 12px rgba(37, 99, 235, 0.06)",
    flexShrink: 0
  },
  titleCopy: {
    minWidth: 0
  },
  title: {
    fontSize: "18px",
    fontWeight: 600,
    lineHeight: 1.25,
    color: "#0f172a",
    margin: 0
  },
  subtitle: {
    fontSize: "12px",
    fontWeight: 600,
    color: "#64748b",
    margin: "2px 0 0 0"
  },
  soonBadge: {
    display: "inline-flex",
    alignItems: "center",
    gap: "6px",
    padding: "7px 16px",
    borderRadius: "999px",
    border: "1px solid rgba(191, 219, 254, 0.9)",
    backgroundColor: "#eff6ff",
    color: "#2563eb",
    fontSize: "12.5px",
    fontWeight: 600
  },
  statsRow: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(200px, 1fr))",
    gap: "14px",
    padding: "20px 22px"
  },
  statCard: {
    display: "flex",
    alignItems: "flex-start",
    gap: "12px",
    backgroundColor: "#ffffff",
    border: "1px solid rgba(226, 232, 240, 0.95)",
    borderRadius: "16px",
    padding: "16px",
    boxShadow: "0 6px 18px rgba(15, 23, 42, 0.03)",
    transition: "all 0.2s ease"
  },
  statIcon: {
    width: "36px",
    height: "36px",
    borderRadius: "10px",
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    background: "#eff6ff",
    color: "#2563eb",
    fontSize: "14px",
    flexShrink: 0
  },
  statContent: {
    minWidth: 0
  },
  statLabel: {
    margin: "0 0 4px 0",
    color: "#64748b",
    fontSize: "11px",
    fontWeight: 600,
    letterSpacing: "0.08em",
    textTransform: "uppercase"
  },
  statValue: {
    margin: 0,
    color: "#0f172a",
    fontSize: "24px",
    fontWeight: 600,
    lineHeight: 1
  },
  body: {
    padding: "0 22px 22px 22px",
    display: "grid",
    gap: "18px"
  },
  sectionCard: {
    borderRadius: "18px",
    border: "1px solid rgba(226, 232, 240, 0.95)",
    background: "#ffffff",
    overflow: "hidden"
  },
  sectionHeader: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    gap: "12px",
    padding: "14px 18px",
    borderBottom: "1px solid rgba(226, 232, 240, 0.9)",
    background: "linear-gradient(135deg, #f8fafc 0%, #eff6ff 100%)"
  },
  sectionTitle: {
    fontSize: "15px",
    fontWeight: 600,
    color: "#0f172a",
    margin: 0
  },
  sectionMeta: {
    fontSize: "12px",
    color: "#64748b",
    marginTop: "1px",
    fontWeight: 600
  },
  sectionBadge: {
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    minWidth: "28px",
    height: "28px",
    padding: "0 10px",
    borderRadius: "999px",
    background: "#eff6ff",
    border: "1px solid rgba(191, 219, 254, 0.9)",
    color: "#2563eb",
    fontSize: "12px",
    fontWeight: 600
  },
  table: {
    width: "100%",
    marginBottom: 0,
    borderCollapse: "separate",
    borderSpacing: 0,
    fontSize: "13px",
    color: "#334155"
  },
  tableHeadCell: {
    borderTop: "none",
    fontSize: "11px",
    fontWeight: 600,
    letterSpacing: "0.08em",
    textTransform: "uppercase",
    color: "#64748b",
    background: "#f8fafc",
    borderBottom: "1px solid rgba(226, 232, 240, 0.9)",
    padding: "14px 16px"
  },
  cell: {
    padding: "14px 16px",
    borderBottom: "1px solid rgba(241, 245, 249, 1)",
    verticalAlign: "top",
    fontWeight: 600
  },
  datePrimary: {
    display: "flex",
    alignItems: "center",
    gap: "6px",
    fontSize: "12.5px",
    fontWeight: 600,
    color: "#0f172a"
  },
  dateSecondary: {
    fontSize: "12px",
    color: "#64748b",
    marginTop: "2px",
    fontWeight: 600
  },
  taskLink: {
    display: "inline-flex",
    alignItems: "center",
    gap: "6px",
    color: "#2563eb",
    fontWeight: 600,
    fontSize: "13px",
    textDecoration: "none"
  },
  officerAvatar: {
    width: "36px",
    height: "36px",
    borderRadius: "10px",
    background: "linear-gradient(135deg, #eff6ff 0%, #dbeafe 100%)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    color: "#2563eb",
    fontSize: "13px",
    fontWeight: 600,
    border: "1px solid rgba(191, 219, 254, 0.9)",
    boxShadow: "0 2px 6px rgba(37, 99, 235, 0.08)",
    flexShrink: 0
  },
  officerName: {
    margin: 0,
    color: "#0f172a",
    fontSize: "14px",
    fontWeight: 600,
    textTransform: "uppercase"
  },
  officerMeta: {
    display: "flex",
    alignItems: "center",
    gap: "6px",
    color: "#475569",
    fontSize: "12.5px",
    lineHeight: 1.45,
    fontWeight: 600
  },
  emptyState: {
    padding: "42px 24px",
    textAlign: "center",
    backgroundColor: "#ffffff",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center"
  },
  emptyIcon: {
    width: "64px",
    height: "64px",
    margin: "0 auto 14px auto",
    borderRadius: "18px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    background: "linear-gradient(135deg, #dbeafe 0%, #eff6ff 100%)",
    color: "#2563eb",
    fontSize: "26px"
  },
  emptyTitle: {
    margin: 0,
    color: "#0f172a",
    fontSize: "18px",
    fontWeight: 600,
    textAlign: "center"
  },
  emptyText: {
    margin: "10px auto 0 auto",
    color: "#64748b",
    fontSize: "14px",
    lineHeight: 1.6,
    fontWeight: 600,
    textAlign: "center"
  }
};

const getInitials = (name) => {
  if (!name) return "??";
  const parts = name.trim().split(" ");
  if (parts.length >= 2) {
    return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
  }
  return name.slice(0, 2).toUpperCase();
};

class SurveyFeedback extends Component {
  constructor(props) {
    super(props);
    this.state = {
      route: [{ url: "", name: "Task Management" }],
      route1: [{ url: "", name: "Contract Management" }],
      appTasklist: [],
      user: {},
    };
  }

  async componentDidMount() {
    let user = auth.getCurrentUser();
    if (user?.id > 0) {
      const { data: appliedApplication } = await http.get(
        config.GetPerformerApplication + user.id
      );

      if (appliedApplication.length > 0) {
        const filterApp = appliedApplication.filter(
          (x) => x.workflowType === 2 && x.type !== "Background Check"
        );
        let appTasklist = [];
        filterApp.map(async (item) => {
          const { data: runningApplication } = await http.get(
            config.GetRunningTask + item.workflowId + "&performerId=" + user.id
          );
          const obj = {
            chkApp: item,
            runningApplication,
          };
          appTasklist.push(obj);
          this.setState({ appTasklist, user });
        });
      }
    }
  }

  handleCurrentTask = async (wiid) => {
    const { data: workflowTask } = await http.get(
      config.GetWorkflowTask + wiid
    );
    if (workflowTask.formId > 0) {
      if (workflowTask.formType === "CF") {
        this.props.history.push({
          pathname: "/" + workflowTask.formName,
          state: { workflowTask },
        });
      } else {
        this.props.history.push({
          pathname: "/DynamicForm",
          state: { workflowTask },
        });
      }
    }
  };

  render() {
    const { appTasklist, user } = this.state;
    const totalSurveyGroups = appTasklist.length;
    const totalSurveyTasks = appTasklist.reduce((count, app) => count + ((app.runningApplication || []).length), 0);
    const actionableTasks = appTasklist.reduce(
      (count, app) => count + (app.runningApplication || []).filter((item) => parseInt(user.id) === item.performerId).length,
      0
    );
    return (
      <React.Fragment>
        <div className="col-md-12 form-group" style={SURVEY_STYLES.pageWrap}>
          <div style={SURVEY_STYLES.shell}>
            <div style={SURVEY_STYLES.hero}>
              <div style={SURVEY_STYLES.heroRow}>
                <div style={SURVEY_STYLES.titleWrap}>
                  <div style={SURVEY_STYLES.titleIcon}>
                    <i className="fa fa-comments-o" aria-hidden="true"></i>
                  </div>
                  <div style={SURVEY_STYLES.titleCopy}>
                    <h1 style={SURVEY_STYLES.title}>Survey Feedback</h1>
                    <p style={SURVEY_STYLES.subtitle}>Review candidate surveys, client feedback, and rating responses.</p>
                  </div>
                </div>
                <div style={SURVEY_STYLES.soonBadge}>
                  <i className="fa fa-bullhorn" aria-hidden="true"></i>
                  Complete Your Surveys Coming Soon
                </div>
              </div>
            </div>
            <div style={SURVEY_STYLES.statsRow}>
              <div style={SURVEY_STYLES.statCard}>
                <div style={SURVEY_STYLES.statIcon}>
                  <i className="fa fa-folder-open-o" aria-hidden="true"></i>
                </div>
                <div style={SURVEY_STYLES.statContent}>
                  <div style={SURVEY_STYLES.statLabel}>Survey Groups</div>
                  <div style={SURVEY_STYLES.statValue}>{totalSurveyGroups}</div>
                </div>
              </div>
              <div style={SURVEY_STYLES.statCard}>
                <div style={SURVEY_STYLES.statIcon}>
                  <i className="fa fa-tasks" aria-hidden="true"></i>
                </div>
                <div style={SURVEY_STYLES.statContent}>
                  <div style={SURVEY_STYLES.statLabel}>Total Tasks</div>
                  <div style={SURVEY_STYLES.statValue}>{totalSurveyTasks}</div>
                </div>
              </div>
              <div style={SURVEY_STYLES.statCard}>
                <div style={SURVEY_STYLES.statIcon}>
                  <i className="fa fa-check-circle-o" aria-hidden="true"></i>
                </div>
                <div style={SURVEY_STYLES.statContent}>
                  <div style={SURVEY_STYLES.statLabel}>Actionable</div>
                  <div style={SURVEY_STYLES.statValue}>{actionableTasks}</div>
                </div>
              </div>
            </div>

            <div style={SURVEY_STYLES.body}>
              {appTasklist.length > 0 ? appTasklist.map((app, appIndex) => (
                <div key={app.chkApp?.workflowId || appIndex} style={SURVEY_STYLES.sectionCard}>
                  <div style={SURVEY_STYLES.sectionHeader}>
                    <div>
                      <h3 style={SURVEY_STYLES.sectionTitle}>Complete Survey(s)</h3>
                      <div style={SURVEY_STYLES.sectionMeta}>
                        {(app.runningApplication || []).length} workflow task{(app.runningApplication || []).length === 1 ? "" : "s"} available in this survey group.
                      </div>
                    </div>
                    <div style={SURVEY_STYLES.sectionBadge}>{(app.runningApplication || []).length}</div>
                  </div>
                  <div className="table-responsive">
                    <table className="table align-items-center table-hover mb-0" style={SURVEY_STYLES.table}>
                      <thead>
                        <tr>
                          <th style={SURVEY_STYLES.tableHeadCell}>ID</th>
                          <th style={SURVEY_STYLES.tableHeadCell}>Date</th>
                          <th style={SURVEY_STYLES.tableHeadCell}>Application Workflow Status</th>
                          <th style={SURVEY_STYLES.tableHeadCell}>Review Officer</th>
                        </tr>
                      </thead>
                      <tbody>
                        {(app.runningApplication || []).map((item, key) => (
                          <tr key={item.wiid || key}>
                            <td style={SURVEY_STYLES.cell}>
                              <span style={{ color: "#2563eb", fontWeight: 700 }}>#</span>{" "}
                              <span style={{ fontWeight: 600, color: "#0f172a" }}>{item.wiid || key + 1}</span>
                            </td>
                            <td style={SURVEY_STYLES.cell}>
                              <div style={{ display: "flex", flexDirection: "column", gap: "2px" }}>
                                <span style={{ fontSize: "13.5px", fontWeight: 600, color: "#0f172a" }}>
                                  <Moment format="MMM Do, YYYY">
                                    {item.startDateTime}
                                  </Moment>
                                </span>
                                <span style={{ fontSize: "12px", fontWeight: 600, color: "#64748b" }}>
                                  <Moment format="h:mm a">
                                    {item.startDateTime}
                                  </Moment>
                                </span>
                              </div>
                            </td>
                            <td style={SURVEY_STYLES.cell}>
                              {parseInt(user.id) === item.performerId ? (
                                <Link
                                  to="#"
                                  style={SURVEY_STYLES.taskLink}
                                  onClick={(event) => {
                                    event.preventDefault();
                                    this.handleCurrentTask(item.wiid);
                                  }}
                                >
                                  <i className="fa fa-file-text-o" aria-hidden="true"></i>
                                  {item.taskName}
                                </Link>
                              ) : (
                                <span style={SURVEY_STYLES.officerName}>{item.taskName}</span>
                              )}
                            </td>
                            <td style={SURVEY_STYLES.cell}>
                              {parseInt(user.id) !== item.performerId ? (
                                <div style={{ display: "flex", alignItems: "flex-start", gap: "10px" }}>
                                  <div style={SURVEY_STYLES.officerAvatar}>
                                    {getInitials(item.performer)}
                                  </div>
                                  <div style={{ display: "flex", flexDirection: "column", gap: "3px", minWidth: 0 }}>
                                    {item.performer !== null && (
                                      <p style={SURVEY_STYLES.officerName}>{item.performer.toUpperCase()}</p>
                                    )}
                                    {item.email !== null && (
                                      <div style={SURVEY_STYLES.officerMeta}>
                                        <i className="fa fa-envelope-o" style={{ fontSize: "11px", color: "#94a3b8" }} aria-hidden="true"></i>
                                        {item.email}
                                      </div>
                                    )}
                                    {item.contact !== null && (
                                      <div style={SURVEY_STYLES.officerMeta}>
                                        <i className="fa fa-phone" style={{ fontSize: "11px", color: "#94a3b8" }} aria-hidden="true"></i>
                                        {item.contact}
                                      </div>
                                    )}
                                  </div>
                                </div>
                              ) : (
                                <span style={{ ...SURVEY_STYLES.officerMeta, color: "#2563eb", fontWeight: 600 }}>
                                  <i className="fa fa-user-circle-o" style={{ fontSize: "11px" }} aria-hidden="true"></i>
                                  Assigned to you
                                </span>
                              )}
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              )) : (
                <div style={SURVEY_STYLES.emptyState}>
                  <div style={SURVEY_STYLES.emptyIcon}>
                    <i className="fa fa-comments-o" aria-hidden="true"></i>
                  </div>
                  <h4 style={SURVEY_STYLES.emptyTitle}>No survey feedback tasks yet</h4>
                  <p style={SURVEY_STYLES.emptyText}>
                    Survey-related workflow tasks will appear here once they are assigned to your account.
                  </p>
                </div>
              )}
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

export default SurveyFeedback;
